

































import { Vue, Component, Prop } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import { EButtonTypes } from '@/enums/ButtonType';
import { SignatureHelper } from '@/helpers/signature.helper';
import { SignatureConstants } from '@signing-page/signing/constants/signature.constants';
import LoaderCircular from '@/components/LoaderCircular.vue';

@Component({
  components: {
    Button,
    LoaderCircular,
  },
  data: () => ({
    EButtonTypes,
  }),
})
export default class SignaturePad extends Vue {
  @Prop({ default: false }) landscapeMode: boolean;
  @Prop({ default: SignatureConstants.drawSignatureHeight }) height: number;
  @Prop({ default: SignatureConstants.drawSignatureWidth }) width: number;
  @Prop({ default: SignatureConstants.saveType }) saveType: string;

  showInfoText: boolean = true;
  signaturePad: any = null;

  options: any = {
    penColor: SignatureConstants.writeSignatureColor,
    onEnd: this.handleSetSignature,
    onBegin: this.hideText,
  };

  get signatureData(): any {
    if (this.signaturePad?._data?.signaturePad?._data) {
      const rawStrokes = this.signaturePad._data.signaturePad._data;
      return SignatureHelper.convertRawStrokes(rawStrokes);
    }
    return [];
  }

  get signatureIsDrawn(): boolean {
    return !!this.signatureData.length;
  }

  get showInfoTextSection(): boolean {
    return this.showInfoText;
  }

  hideText() {
    this.showInfoText = false;
  }

  handleReset() {
    if (!this.signaturePad) {
      return;
    }
    this.signaturePad.clearSignature();
    this.$emit('reset');
  }

  handleUndo() {
    this.signaturePad.undoSignature();
    this.handleSetSignature();
  }

  handleSetSignature() {
    const jSignature: string[] = SignatureHelper.signPadNativeToJSignature(this.signatureData);
    const signatureBase30: string = SignatureHelper.nativeToBase30(jSignature);
    const { isEmpty, data } = this.signaturePad.saveSignature();
    if (!!signatureBase30 && !isEmpty) {
      this.$emit('signature', { signatureBase30, signatureBase64: data });
    } else {
      this.$emit('reset');
    }
  }

  async mounted() {
    this.signaturePad = this.$refs.signaturePad;
  }
}
